/**
 * Build auth paths with referral code and preserved query (UTM, etc.).
 */
export function buildReferralAuthPath(pathname, referralCode, search = "") {
  const params = new URLSearchParams(search);
  const code = (referralCode || "").trim();
  if (code) {
    params.set("ref", code);
  }
  const query = params.toString();
  return query ? `${pathname}?${query}` : pathname;
}

/** Mobile login/signup entry with referral (and UTM) preserved. */
export function buildReferralLoginPath(referralCode, search = "") {
  return buildReferralAuthPath("/login", referralCode, search);
}
